<script setup lang="ts">
import { cva } from 'class-variance-authority'

interface Props {
    count: number
    hide?: boolean
    trinity?: boolean
}

withDefaults(defineProps<Props>(), {
    size: 'md',
    hide: true
})

const badgeClasses = cva(
    ['inline-flex', 'min-w-fit', 'items-center', 'justify-center', 'rounded-md', 'font-semibold', 'transition-opacity'],
    {
        variants: {
            trinity: {
                true: ['size-5', 'text-xs', 'mr-3', 'bg-gray-300', 'text-gray-800'],
                false: ['size-6', 'text-xs', 'bg-gray-200', 'text-gray-600']
            },
            hide: {
                true: ['opacity-0', 'group-hover:opacity-100'],
                false: ['opacity-100']
            }
        }
    }
)
</script>

<template>
    <span :class="badgeClasses({ trinity, hide })">
        {{ count }}
    </span>
</template>
